import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import { getOtherProperties } from "../common/Utils";
import { Fade } from "../Transitions";
import Portal from "../Portal";
import Swiper from "../Swiper";
import { ImageViewProps } from "./PropsType";

export default function ImageView(props: ImageViewProps) {
  const {
    className,
    target = document.body,
    prefixCls = "bm-ImageView",
    ...other
  } = props;
  const styleClass = classNames(prefixCls, className);
  const otherProps = getOtherProperties(other, [
    "target",
    "visible",
    "onClose",
    "onOpen",
  ]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [visible, setVisible] = useState(!!props.visible);
  const [images, setImages] = useState<Array<string>>([]);
  const handleClose = () => {
    if (props.onClose) {
      (props.onClose as () => void)();
    }
  };

  const transitionEnd = (activeIndex: number) => {
    if (activeIndex >= 0) {
      setActiveIndex(activeIndex);
    }
  };

  useEffect(() => {
    if (props.target) {
      const data: Array<string> = [];
      const target: any = props.target;
      if (target.querySelectorAll) {
        const imgs = target.querySelectorAll("img");
        for (const img of imgs) {
          data.push(img.src);
        }
      }
      setImages(data);
    }
    setVisible(!!props.visible);
  }, [props.target, props.visible]);

  return (
    <Portal mountNode={document.body} visible={visible}>
      <div className={styleClass} {...otherProps}>
        <Fade in={visible}>
          <div className={`${prefixCls}-backdrop`} onClick={handleClose} />
          <div className={`${prefixCls}-label`}>
            {`${activeIndex + 1}/${images?.length || 0}`}
          </div>
          <div className={`${prefixCls}-container`} key="ImageView">
            <Swiper navigation={true} on={{ transitionEnd }}>
              {(images as Array<string>).map((src: any, index: number) => {
                return (
                  <div className={`${prefixCls}-item`} key={index}>
                    <img src={src} />
                  </div>
                );
              })}
            </Swiper>
          </div>
        </Fade>
      </div>
    </Portal>
  );
}
